import React from "react";
//outsource
import { Row, Col, Button, Space, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
//components

//redux
import { useDispatch } from "react-redux";
import {
  setOpenGroupAdd,
  setOpenServiceAdd,
} from "../../../store/var/var.action";
import { setSearch } from "../../../store/var/var.action";

const { Search } = Input;

const GroupService = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleOpenGroup = () => {
    dispatch(setOpenGroupAdd({ data: true }));
  };

  const handleOpenService = () => {
    dispatch(setOpenServiceAdd({ data: true }));
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    dispatch(setSearch({ data: value }));
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Row gutter={[10, 10]} className="group-service">
      <Col xl={8} lg={12} md={24} xs={24}>
        <Search placeholder="Search service.." onChange={handleSearch} />
      </Col>
      <Col align="right" xl={16} lg={12} md={24} xs={24}>
        <Space>
          <Button
            className="btn-add green"
            icon={<PlusOutlined />}
            type="primary"
            onClick={handleOpenGroup}
          >
            Add Group
          </Button>
          <Button
            className="btn-add"
            icon={<PlusOutlined />}
            type="primary"
            onClick={handleOpenService}
          >
            Add Service
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

export default GroupService;
